/* global angular, moment */

(function () {
  'use strict';
  angular.module('vcutils.doctor')
    .component('doctoreditor', {
      restrict: 'E',
      bindings: {
        doctor: '<?',
        doctorid: '<?'
      },
      template: `
        <doctorform doctor="vm.doctor" parentsave="vm.childsave(doctor)" oncancel="vm.oncancel()"></doctorform>
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Arzt/Institut erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Arztes/Instituts wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Arzt/Institut  konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Doctor', 'Rlog', '$timeout',
        function ($log, Doctor, Rlog, $timeout) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.zipsave = zipsave;
          vm.oncancel = oncancel;

          vm.$onInit = function () {
            if ((angular.isUndefined(vm.doctor) || !vm.doctor.hasOwnProperty('_id')) && angular.isDefined(vm.doctorid)) {
              Doctor.$find(vm.doctorid).$then(function (doctor) {
                vm.doctor = doctor;
              }, function (err) {
                $log.error('doctor not found, id: ', vm.doctorid, err);
                Rlog.error('doctor', 'doctoreditor', 'doctor not found', {_id: vm.doctorid, error: err});
              });
            }
          };

          function childsave(doctor) {
            // vm.doctor = angular.copy(doctor);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in doctor) {
              if (doctor.hasOwnProperty(key)) {
                vm.doctor[key] = doctor[key];
              }
            }
            vm.save();
          }

          function zipsave(zip, city) {
            vm.doctor.postcode = zip;
            vm.doctor.city = city;
            vm.save();
          }

          function save() {
            // Create formatted name string for use with doctorsearch box
            if (angular.isString(vm.doctor.lastname) && !angular.isString(vm.doctor.institute)) {
              vm.doctor.fname = vm.doctor.titlefront + ' ' + vm.doctor.firstname + ' ' + vm.doctor.lastname + ', ' + vm.doctor.city;
            }
            if (!angular.isString(vm.doctor.lastname) && angular.isString(vm.doctor.institute)) {
              vm.doctor.fname = vm.doctor.institute + ', ' + vm.doctor.city;
            }
            if (angular.isString(vm.doctor.lastname) && angular.isString(vm.doctor.institute)) {
              vm.doctor.fname = vm.doctor.institute + ', ' + vm.doctor.titlefront + ' ' + vm.doctor.lastname + ', ' + vm.doctor.city;
            }

            if (vm.doctor.$hasPendingActions()) {
              vm.doctor.$cancel();
              vm.doctor.$save().$then(function () {
                vm.saved = true;
                reset('saved');
              }, function (err) {
                vm.saved = false;
                reset('saved');
                $log.error('saving of doctor failed: ', err);
                Rlog.error('vcutils.doctor', 'doctoreditor', 'Saving of doctor failed: ', {error: err, doctorid: vm.doctor._id});
              });
            } else {
              vm.doctor.$save().$then(function () {
                vm.saved = true;
                reset('saved');
              }, function (err) {
                vm.saved = false;
                reset('saved');
                $log.error('saving of doctor failed: ', err);
                Rlog.error('vcutils.doctor', 'doctoreditor', 'Saving of doctor failed: ', {error: err, doctorid: vm.doctor._id});
              });
            }
          }

          function oncancel() {
            vm.canceled = true;
            reset('save');
          }

          function reset(rvar) {
            $timeout(function () {
              delete vm[rvar]
            }, 3500);
          }


        }] // controller
    }); // component

// klammerfriedhof
}());